import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";
import { Col, CustomCheckbox, Row } from "../../mycomponents/DynamicForm";

export const reimbursementAdvancesfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {

  const formFields = [
    {
      type: 'divider',
      heading: 'Reimbursement Advances Details',
      visible: true,
      span: 24,
    },
    {
      label: 'Date',
      key: 'date',
      type: 'date',
      placeholder: 'Enter Date',
      visible: true,
      width: '25%',
      value: new Date()
    },
    {
      label: 'Employee',
      key: 'employee_id',
      type: 'select',
      placeholder: 'Select Employee',
      visible: true,
      width: '25%',
      options: (response.Employees || []).map((item) => {
        return {
          ...item,
          label: item.name,
          value: item._id
        }
      })
    },
    {
      label: 'Cash Account Id',
      key: 'cash_account_id',
      type: 'select',
      placeholder: 'Enter Cash Account Id',
      visible: true,
      width: '25%',
      options: (response.CashAccounts || []).map((item) => {
        return {
          ...item,
          label: item.name,
          value: item._id
        }
      })
    },
    {
      label: 'Amount',
      key: 'amount',
      type: 'number',
      placeholder: 'Enter Amount',
      visible: true,
      width: '25%',
    },
    {
      label: 'Remarks',
      key: 'remarks',
      type: 'text',
      placeholder: 'Enter Remarks',
      visible: true,
      width: '25%',
    }
  ];

  const CustomFields = response.CustomFields;

  if (CustomFields && CustomFields.length > 0) {
    CustomFields.forEach((field) => {
      formFields.push({
        label: field.name,
        key: 'cf.' + field.key,
        type: field.type,
        placeholder: field.placeholder,
        visible: true,
        width: '25%'
      });
    });
  }

  return formFields;
}

export const reimbursementAdvancesMobileCard = (item, index, getFieldValue) => {
  return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
    <View>
      <Text>TEST</Text>
      <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
    </View>
  </Card>;
}

export const reimbursementAdvancesMain = {
  fields: reimbursementAdvancesfields,
  mobileCard: null
}